<template lang="pug">
.tweet-button(ref="root")
</template>

<script>
export default {
  name: "tweet-button",
  props: {
    url: {
      type: String,
      required: true
    },
    text: String,
    hashtags: Array,
    lang: {
      type: String,
      default: "ja"
    }
  },
  mounted() {
    twttr.widgets.createShareButton(this.url, this.$refs.root, {
      lang: this.lang,
      text: this.text || null,
      hashtags: this.hashtags ? this.hashtags.join(",") : null
    });

    this._clickHandler = () => {
      this.$emit("click");
    };
    twttr.events.bind("click", this._clickHandler);
  },
  destroyed() {
    twttr.events.unbind("click", this._clickHandler);
  }
};
</script>
